<template>
  <!-- <van-row>
    <van-col span="6">
      <van-image width="80" height="80" :src="info.picUrl" />
    </van-col>
    <van-col span="17" class="cellright">

      <van-row class="cell1">{{info.goodsName}}</van-row>
      <van-row class="cell2">{{info.number}}件</van-row>
      <van-row class="cell3">价格：￥{{info.price}} <span class="to-evaluate" v-if="isShowBtn && info.comment ==0" @click="navToEvaluate">评价</span>
      </van-row>

    </van-col>

  </van-row> -->
  <div class="product-list" v-if="info">
    <van-card :thumb="info.picUrl">
      <template #desc>
        <div class="product-item">
          <div class="select-data">{{info.goodsName}}</div>
          <div class="select-guige">
            <div class="select-guige-item" v-for="(goods,idx) in info.specifications" :key="idx">{{goods}}</div>
          </div>
          <div class="price-number">
            <div>￥{{info.price.toFixed(2)}}</div>
            <div>x{{info.number}}</div>
          </div>
          <div class="to-eval-box" v-if="isShowBtn">
            <div class="to-evaluate" @click="navToEvaluate">评价</div>
          </div>

        </div>

      </template>
    </van-card>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "goodscell",
  props: {
    info: {
      type: Object
    },
    isShowBtn: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    navToEvaluate() {
      console.log(this.info);

      this.$router.push({
        path: "/evaluate",
        query: {
          orderGoodsId: this.info.id
        }
      });
    }
  }
};
</script>

<style scoped lang="scss">
.product-list {
  width: 95.2%;
  margin: 0 auto 1rem;
  box-sizing: border-box;
  background: #fff;
  // box-shadow: 0 5px 1.6rem 0 rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  overflow: hidden;
  .product-item {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    .select-data {
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #424242;
      line-height: 1.4rem;
      padding-left: 1rem;
      text-align: left;
    }
    .select-guige {
      background: #f7f7f7;
      border-radius: 2px;
      padding: 0.6rem;
      display: inline-block;
      font-family: PingFangSC-Regular;
      font-size: 1.2rem;
      color: #9c9c9c;
      letter-spacing: 0;
      line-height: 1.2rem;
      margin-left: 1rem;
      margin-top: 0.8rem;
    }
    .price-number {
      display: flex;
      justify-content: space-between;
      margin-top: 1.6rem;
      padding-left: 1rem;
      box-sizing: border-box;
      width: 100%;
      div:first-child {
        font-family: PingFangSC-Regular;
        font-size: 1rem;
        color: #fe5845;
        letter-spacing: 0;
        line-height: 1.4rem;
      }
      div:last-child {
        opacity: 0.5;
        font-family: PingFangSC-Regular;
        font-size: 1.2rem;
        color: #424242;
        letter-spacing: 0;
        line-height: 1.4rem;
      }
    }
    .to-eval-box {
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      width: 100%;
      margin-top: 1rem;
      .to-evaluate {
        background: #d6be93;
        border-radius: 16px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #ffffff;
        letter-spacing: 0;
        text-align: center;
        line-height: 2.2rem;
        margin-left: 1.2rem;
        border: 1px solid #e0e1e0;
        padding: 0 1rem;
      }
    }
  }
  /deep/ .van-card {
    background: #fff;
    padding: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/goodscell.vue